import React from 'react';

const Skills = () => {
  return (
    <section id="skills" className="section">
      <h2 className="section-title">Our Skills</h2>
      <div className="section-content">
        <div className="skill-category">
          <h3>Google Cloud Architecture</h3>
          <p>We are experts in designing and building scalable and resilient cloud infrastructure on Google Cloud Platform. Our team holds multiple Google Cloud certifications, including the Google Certified Professional - Cloud Architect.</p>
        </div>
        <div className="skill-category">
          <h3>Data Engineering</h3>
          <p>We build and maintain robust and efficient data pipelines. Our expertise in data engineering is backed by certifications like the Google Certified Professional - Data Engineer and Databricks Data Engineering Associate.</p>
        </div>
        <div className="skill-category">
          <h3>BigQuery</h3>
          <p>We can help you unlock the power of your data with Google's serverless data warehouse. We have extensive experience in designing and optimizing BigQuery for large-scale data analytics.</p>
        </div>
        <div className="skill-category">
          <h3>Agent Development</h3>
          <p>We design and build intelligent agents and chatbots to automate your business processes and enhance customer engagement.</p>
        </div>
        <div className="skill-category">
          <h3>Kubernetes FinOps</h3>
          <p>We help you optimize your Kubernetes spending and gain financial accountability for your cloud-native applications. Our expertise is validated by certifications like the Linux Foundation CKAD.</p>
        </div>
      </div>
    </section>
  );
};

export default Skills;
